import Dialog from '@mui/material/Dialog'
import { useEffect, useState } from 'react'
import ReactPlayer from 'react-player'
import { connect } from 'react-redux'

const VideoPreviewDialog = ({ courseData, dispatch, ...props }) => {
  const [courseDetails, setCourseDetails] = useState()

  useEffect(() => {
    if (courseData) {
      dispatch({
        type: 'courseTemplate/getCourseTemplateById',
        payload: { courseTempId: courseData.templateId },
        successCallback: responseData => {
          setCourseDetails(responseData)
        },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [courseData])

  return (
    <Dialog
      {...props}
      maxWidth={'md'}
      fullWidth
      open={!!courseData}
      PaperProps={{ sx: { width: 'auto' } }}
    >
      <ReactPlayer
        style={{ backgroundColor: 'black' }}
        height={'auto'}
        controls={true}
        url={courseDetails?.courseSrc}
      />
    </Dialog>
  )
}

export default connect()(VideoPreviewDialog)
